@import "../../global.scss";

lw-searchahead {
  --font-size: 12px;

  /** Search Input */
  --input-width: 640px;
  --input-height: 32px;
  --input-font-size: var(--font-size);
  --input-padding: 4px;
  --input-margin: 0;
  --input-box-shadow: none;
  --input-outer-box-shadow: none;
  --input-border: 1px solid #ebeced;
  --input-border-radius: 4px;
  --input-focus-border-color: #666;
  --input-hover-border-color: #999;
  --input-focus-box-shadow: none;
  --input-bg-color: #f9fafb;
  --input-font-color: #0b1731;
  --input-flex-direction: row;
  --input-focus-outline: none;
  --input-cursor: default;
  --input-overflow: hidden;

  /** Search Icon */
  --search-icon-width: 35px;
  --search-icon-margin: 0;
  --search-icon-bg-color: #f9fafb;
  --search-icon-hover-bg-color: #f9fafb;
  --search-icon-border-radius: 4px;
  --search-icon-bg-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='18' height='18' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.5 11h-.79l-.28-.27A6.471 6.471 0 0 0 13 6.5 6.5 6.5 0 1 0 6.5 13c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L17.49 16l-4.99-5zm-6 0C4.01 11 2 8.99 2 6.5S4.01 2 6.5 2 11 4.01 11 6.5 8.99 11 6.5 11z' fill='rgba(97, 89, 104, 0.9999)' fill-rule='nonzero'/%3E%3C/svg%3E");
  --search-icon-hover-bg-image: var(--search-icon-bg-image);
  --search-icon-bg-size: 14px;
  --search-icon-bg-position: 14px 50%;

  /** Clear Button */
  --clear-button-display: block;
  --clear-button-width: 30px;
  --clear-button-bg-size: 8px;
  --clear-button-bg-position: 50%;
  --clear-button-bg-color: #f9fafb;

  /** DropDown Menu & Items */
  --menu-max-height: calc(80vh);
  --menu-min-width: unset;
  --menu-border-radius: 0px;
  --menu-margin: 0px;
  --menu-box-shadow: 0 2px 8px 1px rgb(0 0 0 / 14%), 0 3px 3px -2px rgb(0 0 0 / 40%);
  --item-font-size: var(--font-size);
  --item-bg-color: #fff;
  --item-hover-bg-color: #efefef;
  --item-color: #333;
  --item-height: 40px;
  --item-padding: 0 4px;
  --item-image-display: block;

  /** Result List Icons **/
  --result-item-icon-display: block;
  --result-item-icon-bg-position: center;
  --result-item-icon-margin-right: 4px;
  --result-item-icon-border-radius: 0px;
  --result-item-icon-bg-size: 20px;
  --result-item-icon-bg-color: #fff;
  --result-item-icon-min-height: 32px;
  --result-item-icon-height: 32px;
  --result-item-icon-min-width: 40px;
  --result-item-icon-width: 40px;
  --result-item-highlight-font-style: normal;
  --result-item-highlight-font-weight: bold;
  --result-item-highlight-display: contents;

  position: relative;
  width: auto;

  mo-search-bar {
    position: relative;
    width: var(--input-width);
    height: var(--input-height);
    background: var(--input-bg-color);
    border: var(--input-border);
    border-radius: var(--input-border-radius);
    flex-direction: var(--input-flex-direction);
    overflow: var(--input-overflow);

    &.show-results {
      z-index: 999;
    }

    &.show-popper.active mo-popper.typeahead-wrapper {
      box-shadow: var(--menu-box-shadow);
    }

    &.active:not(.disabled) {
      border-color: var(--input-focus-border-color);
    }

    &.active:not(.disabled),
    &:not(.disabled) {
      box-shadow: var(--input-outer-box-shadow);
    }

    &:hover {
      border-color: var(--input-hover-border-color);
    }

    .search-bar-input {
      background-color: var(--input-bg-color);
      padding: var(--input-padding);
      margin: var(--input-margin);
      box-shadow: var(--input-box-shadow);
      font-size: var(--input-font-size);
      color: var(--input-font-color);
      cursor: var(--input-cursor);

      &:focus {
        outline: var(--input-focus-outline);
        box-shadow: var(--input-focus-box-shadow);
      }
    }

    .search-bar-button {
      position: relative;
      min-width: var(--search-icon-width);
      background-image: var(--search-icon-bg-image);
      background-size: var(--search-icon-bg-size);
      background-position: var(--search-icon-bg-position);
      background-color: var(--search-icon-bg-color);
      border-radius: var(--search-icon-border-radius);
      margin: var(--search-icon-margin);

      &:hover {
        background-image: var(--search-icon-hover-bg-image);
        background-color: var(--search-icon-hover-bg-color);
      }
    }

    .search-bar-clear {
      min-width: var(--clear-button-width);
      background-position: var(--clear-button-bg-position);
      background-size: var(--clear-button-bg-size);
      background-color: var(--clear-button-bg-color);
      display: var(--clear-button-display);
    }

    .typeahead-wrapper {
      border-radius: var(--menu-border-radius);
      min-width: var(--menu-min-width);
      display: flex;
      overflow: hidden;
      flex-direction: column;
      background-color: #fff;
      margin-top: 1px;
      width: auto;
      font-size: 13px;

      &:empty {
        visibility: hidden;
      }

      .result-list {
        max-height: var(--menu-max-height);
        overflow-y: auto;
        border: var(--menu-border);
        margin: var(--menu-margin);
      }

      .result-list-item {
        display: flex;
        background-color: var(--item-bg-color);
        align-items: center;
        color: var(--item-color);
        font-size: var(--item-font-size);
        padding: var(--item-padding);
        height: var(--item-height);
        cursor: pointer;

        .item {
          @include singleLineTrunc;
          line-height: var(--item-height);

          em {
            font-style: var(--result-item-highlight-font-style);
            font-weight: var(--result-item-highlight-font-weight);
            display: var(--result-item-highlight-display);
          }
        }

        &:hover {

          &,
          .show-icon {
            background-color: var(--item-hover-bg-color);
          }
        }
      }

      .image {
        display: var(--item-image-display);
      }

      .image.show-icon,
      .config-image {
        object-fit: cover;
        display: var(--result-item-icon-display);
        margin-right: var(--result-item-icon-margin-right);
        border-radius: var(--result-item-icon-border-radius);
        background-size: var(--result-item-icon-bg-size);
        background-position: var(--result-item-icon-bg-position);
        background-color: var(--result-item-icon-bg-color);
        min-height: var(--result-item-icon-min-height);
        width: var(--result-item-icon-width);
        min-width: var(--result-item-icon-min-width);
        height: var(--result-item-icon-height);

        &.page {
          @include svg_page();
        }

        &.file {
          @include svg_file();
        }

        &.case {
          @include svg_case();
        }

        &.error {
          @include svg_file();
        }
      }
    }
  }

  /** REVIEW: Might be cleaned up from embeds **/

  .inline-error-text {
    color: appColor(red, 6);
    font-size: 12px;
    margin-top: 4px;
  }

  &.max-length-exceeded {
    border-color: appColor(red, 6);
  }
}

lw-searchahead {

  &,
  mo-search-bar .search-bar-input {
    font-family: var(--font-family);
  }
}